import { schema } from "normalizr";

const stateSchema = new schema.Entity(
	"state",
	{},
	{ idAttribute: (value) => value || "errorState" }
);

export default stateSchema;
